import {RcFile} from 'antd/es/upload';
import {UploadFile} from 'antd/es/upload/interface';

export type {UploadFile};
export interface IUploadFileExtended<T=any> extends UploadFile<T> {
    attachmentId?: string;
    sign?: File;
    signRemovedFile?: boolean;
    signName?: string;
    file?: RcFile;
    id?: number;
}

export interface IFileDto {
    id?: number;
    uid: string;
    name: string;
    url?: string;
    status?: string;
    signName?: string;
    signUrl?: string;
    file?: File;
    sign?: Blob;
    attachmentId?: string;
    objectId?: string;
    removedFile?: boolean;
    signRemovedFile?: boolean;
}

export interface IAttachment {
    attachmentId: string;
    fileName: string;
    fileSize: number;
    fileHashCode: string;
    objectId: number;
    outputFileSize: string;
    signatureFileName: string;
}

export type TFileList = UploadFile<Blob>|IFileDto|IAttachment

// export interface FileDto {
//     objectType: string;
//     objectId: number;
//     fileName: string;
//     filePath: string | null;
//     fileSize: number;
//     outputFileSize: string | null;
//     fileExtension: string;
//     fileHashCode: string;
//     signatureFileName: string | null;
//     xmlValidateStatusCode: string;
//     xmlValidateStatusName: string;
//     version: string | null;
// }

export enum EFileType {
    FILE = 'file',
    SIGNATURE = 'signature',
    ATTORNEY = 'attorney',
}

export enum EDocStatusCodes {
    DELETED = 'DELETED',
    DELETED_AFTER_PUBLISH = 'DELETED_AFTER_PUBLISH',
    PUBLISHED = 'PUBLISHED',
    WAITING_FOR_PUBLISH = 'WAITING_FOR_PUBLISH',
    DRAFT = 'DRAFT',
    PUBLISH_CANCELLED = 'PUBLISH_CANCELLED',
    BY_AGREEMENT = 'BY_AGREEMENT',
    AGREE = 'AGREE',
    ON_CHECK = 'ON_CHECK',
    SIGNING = 'SIGNING',
    SIGN_ERROR = 'SIGN_ERROR',
    SIGNED = 'SIGNED',
    VERIFIED = 'VERIFIED',
    RETURN_FOR_REVISION = 'RETURN_FOR_REVISION',
    ERROR = 'ERROR',
    PROCESSING = 'PROCESSING',
    PROCESSING_DELETE = 'PROCESSING_DELETE',
    DOWNLOADED = 'DOWNLOADED',
    NOT_DOWNLOADED = 'NOT_DOWNLOADED',
    DELETED_FROM_AIS = 'DELETED_FROM_AIS',
}
